import { render, staticRenderFns } from "./compositeHeader.vue?vue&type=template&id=38b3a078&scoped=true&"
import script from "./compositeHeader.vue?vue&type=script&lang=js&"
export * from "./compositeHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b3a078",
  null
  
)

export default component.exports